// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandSelector_container__16ApK"};